import { memo } from 'react'

import PublishedGames, { TEST_ID } from './PublishedGames'

const PublishedGamesComponent = memo(PublishedGames)

export { TEST_ID }

export default PublishedGamesComponent
